import React from 'react';

export function FacebookIcon(props) {
	return (<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
		<g clip-path="url(#clip0_16088_42929)">
			<path d="M26 13.0781C26 5.89888 20.1793 0.078125 13 0.078125C5.82075 0.078125 0 5.89888 0 13.0781C0 19.5673 4.75367 24.945 10.9688 25.92V16.8362H7.66783V13.077H10.9688V10.2149C10.9688 6.95729 12.9101 5.15679 15.8795 5.15679C17.3008 5.15679 18.7893 5.41138 18.7893 5.41138V8.61046H17.1492C15.5339 8.61046 15.0302 9.61254 15.0302 10.6406V13.0781H18.6355L18.0592 16.8373H15.0302V25.921C21.2463 24.945 26 19.5662 26 13.0781Z" fill="white" />
		</g>
		<defs>
			<clipPath id="clip0_16088_42929">
				<rect width="26" height="26" fill="white" />
			</clipPath>
		</defs>
	</svg>);
}